import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import { format } from "date-fns";
import toast from "react-hot-toast";

export default function AdminNewsletter() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "newsletter"), orderBy("subscribedAt", "desc"));
    getDocs(q)
      .then(snap => setSubscribers(snap.docs.map(d => ({ id: d.id, ...d.data() }))))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const copyAll = () => {
    const emails = subscribers.map(s => s.email).join("\n");
    navigator.clipboard.writeText(emails).then(() => toast.success(`${subscribers.length} emails copied.`));
  };

  const formatDate = (ts) => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return format(d, "dd MMM yyyy, HH:mm");
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 32, flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: "10px", letterSpacing: "0.2em", textTransform: "uppercase", color: "var(--gold)", marginBottom: 8 }}>
            Newsletter
          </div>
          <h2 style={{ fontSize: "1.6rem" }}>Subscribers</h2>
        </div>
        {subscribers.length > 0 && (
          <button onClick={copyAll} className="btn btn-outline" style={{ fontSize: "12px" }}>
            Copy All Emails ({subscribers.length})
          </button>
        )}
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 32 }}>
        {[
          { val: subscribers.length, label: "Total Subscribers" },
          { val: subscribers.filter(s => {
            const d = s.subscribedAt?.toDate?.() || new Date(s.subscribedAt);
            const now = new Date();
            return (now - d) < 7 * 24 * 60 * 60 * 1000;
          }).length, label: "This Week" },
          { val: subscribers.filter(s => {
            const d = s.subscribedAt?.toDate?.() || new Date(s.subscribedAt);
            const now = new Date();
            return (now - d) < 30 * 24 * 60 * 60 * 1000;
          }).length, label: "This Month" },
        ].map(s => (
          <div key={s.label} style={{
            padding: "20px 24px",
            background: "var(--bg-card)",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius)",
          }}>
            <div style={{ fontFamily: "var(--font-serif)", fontSize: "2rem", color: "var(--gold)", lineHeight: 1, marginBottom: 8 }}>
              {loading ? "—" : s.val}
            </div>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: "10px", letterSpacing: "0.12em", color: "var(--text-muted)", textTransform: "uppercase" }}>
              {s.label}
            </div>
          </div>
        ))}
      </div>

      {/* Subscriber list */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: "var(--radius)", overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: 24 }}>{[1,2,3].map(i => <div key={i} className="skeleton" style={{ height: 44, marginBottom: 8 }} />)}</div>
        ) : subscribers.length === 0 ? (
          <div style={{ padding: "60px 24px", textAlign: "center", color: "var(--text-muted)", fontFamily: "var(--font-mono)", fontSize: "12px" }}>
            No subscribers yet.
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "var(--bg-secondary)" }}>
                {["#", "Email", "Date Subscribed"].map(h => (
                  <th key={h} style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontFamily: "var(--font-mono)",
                    fontSize: "9px",
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    color: "var(--text-muted)",
                    fontWeight: 400,
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {subscribers.map((sub, i) => (
                <tr key={sub.id} style={{ borderTop: "1px solid var(--border)" }}>
                  <td style={{ padding: "12px 16px", fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)" }}>
                    {i + 1}
                  </td>
                  <td style={{ padding: "12px 16px", fontSize: "14px", color: "var(--text-primary)" }}>
                    {sub.email}
                  </td>
                  <td style={{ padding: "12px 16px", fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)" }}>
                    {formatDate(sub.subscribedAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
